import { editShippingCostApi } from "./editShippingCostApi";

export const editShippingCostSetData = async (
  lang,
  setMessageResponse,
  cookies,
  credintial,
  setSuccessMessage,
  setBtnLoader,
  cost_id
) => {
  const response = await editShippingCostApi(credintial, lang, cookies , cost_id);
  if (response.success) {
    setSuccessMessage((prev) => ({
      ...prev,
      success: true,
      type: "updateCost",
      data: response.res.data.data,
    }));
    setBtnLoader(() => false);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
      setBtnLoader(() => false);
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
      setBtnLoader(() => false);
    }
  }
};
